import { render, staticRenderFns } from "./DialogCreateField.vue?vue&type=template&id=16815bef&scoped=true"
import script from "./DialogCreateField.vue?vue&type=script&lang=js"
export * from "./DialogCreateField.vue?vue&type=script&lang=js"
import style0 from "./DialogCreateField.vue?vue&type=style&index=0&id=16815bef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16815bef",
  null
  
)

export default component.exports